export default __webpack_public_path__ + "static/national-metric-desktop-e941c5c85e89bb4b0152a7b77d5d70fe.svg";